import {useCallback, useEffect, useMemo, useState} from "react";

const DIALOG_SELECTOR = "[data-genie-dialog-id]";

const useHasOpenDialog = (excludedDialogIds: string[] = []) => {
    const [hasOpenDialog, setHasOpenDialog] = useState(false);
    const excludedIdsKey = useMemo(() => excludedDialogIds.join("|"), [excludedDialogIds]);

    const getHasOpenDialog = useCallback(() => {
        if (typeof document === "undefined") {
            return false;
        }

        const excludedIds = new Set(excludedIdsKey ? excludedIdsKey.split("|") : []);

        return Array.from(document.querySelectorAll<HTMLElement>(DIALOG_SELECTOR)).some((element) => {
            const dialogId = element.dataset.genieDialogId;
            return !dialogId || !excludedIds.has(dialogId);
        });
    }, [excludedIdsKey]);

    useEffect(() => {
        if (typeof document === "undefined") {
            return;
        }

        const updateState = () => {
            setHasOpenDialog(getHasOpenDialog());
        };

        updateState();

        const observer = new MutationObserver(() => {
            updateState();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, [getHasOpenDialog]);

    return hasOpenDialog;
};

export default useHasOpenDialog;
